import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig, ShimmerBookCoverContainer } from '../styles';

var ShimmerBookCover = function ShimmerBookCover(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["size", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Shimmer',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(ShimmerBookCoverContainer, _extends({
    customTheme: componentTheme,
    size: size
  }, props));
};

ShimmerBookCover.displayName = 'ShimmerBookCover';
export default ShimmerBookCover;